<template>
  <div>
    <header>
      <div class="left">
        <h2>People</h2>
        <p v-if="app_user.role !== 'SuperAdmin'">{{ this.org.orgName }}</p>
      </div>

      <div class="right">
        <a class="main-action" @click="openNewModal()">New user</a>
      </div>
    </header>

    <div class="flex-between">
      <search-box :onChange="handleSearch" />
      <dropdown
        :options="orgOptions"
        :value="orgId"
        :onChange="val => (orgId = val)"
        v-if="app_user.role === 'SuperAdmin'"
      />
    </div>

    <table class="acada-table people">
      <colgroup>
        <col style="width: 34%" />
        <col style="width: 22%" />
        <col style="width: 22%" />
        <col style="width: 22%" />
        <col style="width: 130px" />
      </colgroup>

      <tr>
        <th>
          <table-header-cell
            label="Name"
            :onChange="changeOrder"
            :options="nameSortOptions"
            :value="orderBy"
          />
        </th>
        <th>Team</th>
        <th>Job title</th>
        <th>
          <table-header-cell
            label="Role"
            :onChange="changeOrder"
            :options="roleSortOptions"
            :value="orderBy"
          />
        </th>
        <th>
          <table-header-cell
            label="Can log in"
            :onChange="changeOrder"
            :options="typeSortOptions"
            :value="orderBy"
          />
        </th>
      </tr>

      <tr
        v-for="person of people"
        :key="person.id"
        @click="openEditModal(person.id)"
      >
        <td>
          {{ person.name }}
          <span>{{ person.email }}</span>
        </td>

        <td>{{ getCategory(person.categoryId) }}</td>

        <td>{{ person.jobTitle }}</td>

        <td>{{ person.role }}</td>

        <td>
          <i class="material-icons green" v-if="person.userType === 'Cognito'"
            >check_circle</i
          >
          <i class="material-icons" v-if="person.userType === 'Contact'"
            >cancel</i
          >
        </td>
      </tr>
    </table>

    <user-modal
      :showing="modalShowing"
      :mode="mode"
      :toggleModal="toggleModal"
      :onSave="saveUser"
      :onDelete="deleteUser"
      :userId="userId"
      :orgId="orgId"
    />
  </div>
</template>

<script>
import UserModal from '../components/UserModal';
import Dropdown from '../components/Dropdown';
import SearchBox from '../components/SearchBox';
import TableHeaderCell from '../components/TableHeaderCell';
import moment from 'moment';

export default {
  name: 'People',
  data() {
    return {
      modalShowing: false,
      mode: 'New',
      userId: -1,
      orgId: this.$store.getters.org.id,
      searchTerm: '',
      orderBy: 'lastName|ASC',
      nameSortOptions: [
        { text: 'Last Name A-Z', value: 'lastName|ASC' },
        { text: 'Last Name Z-A', value: 'lastName|DESC' },
      ],
      roleSortOptions: [
        { text: 'Role A-Z', value: 'role|ASC' },
        { text: 'Role Z-A', value: 'role|DESC' },
      ],
      typeSortOptions: [
        { text: 'User type A-Z', value: 'userType|ASC' },
        { text: 'User type Z-A', value: 'userType|DESC' },
      ],
    };
  },
  computed: {
    orgs() {
      return this.$store.getters.all_orgs;
    },
    org() {
      return this.$store.getters.org;
    },
    orgOptions() {
      const orgs = [...this.orgs];
      return orgs
        .sort((a, b) => {
          if (a.orgName < b.orgName) return -1;
          return 1;
        })
        .map(org => {
          return { value: org.id, text: org.orgName };
        });
    },
    people() {
      const users = this.$store.getters.orgUsers;
      const search = this.searchTerm.toLowerCase();
      const sort = this.orderBy.split('|');
      const order = sort[0];
      const direction = sort[1] === 'ASC' ? -1 : 1;

      return Object.keys(users)
        .sort((a, b) => {
          if (users[a][order] < users[b][order]) return direction;
          return -direction;
        })
        .map(id => users[id])
        .filter(user => {
          if (user && search) {
            const fnameMatch = user.firstName.toLowerCase().includes(search);
            const lnameMatch = user.lastName.toLowerCase().includes(search);
            return fnameMatch || lnameMatch;
          }
          return user;
        });
    },
    categories() {
      return this.$store.getters.categories;
    },
    app_user() {
      return this.$store.getters.app_user;
    },
  },
  methods: {
    getCategory(id) {
      if (!id || !this.categories || !this.categories[id]) return '-';
      return this.categories[id].name;
    },
    getUsers() {
      this.$store.dispatch('getOrgUsers', this.orgId);
    },
    saveUser(user) {
      let method = 'createUser';
      let user_copy = JSON.parse(JSON.stringify(user));

      if (user.userId) {
        method = 'updateUser';

        user_copy = {
          id: user.id,
          firstName: user.firstName,
          lastName: user.lastName,
          jobTitle: user.jobTitle,
          organizationId: user.organizationId,
        };
      }

      return this.$store.dispatch(method, user_copy);
    },
    deleteUser(user) {
      return this.$store.dispatch('deleteUser', user);
    },
    toggleModal(showing) {
      if (!showing) {
        this.userId = null;
      }
      this.modalShowing = showing;
    },
    openNewModal() {
      this.mode = 'New';
      this.userId = -1;
      this.modalShowing = true;
    },
    openEditModal(id) {
      this.mode = 'Edit';
      this.userId = id;
      this.modalShowing = true;
    },
    formatDate(date) {
      return moment(date).format('DD MMM YYYY');
    },
    handleSearch(term) {
      this.searchTerm = term;
    },
    changeOrder(param) {
      this.orderBy = param;
    },
  },
  created() {
    this.getUsers();
  },
  watch: {
    orgId() {
      this.getUsers();
    },
  },
  components: {
    'search-box': SearchBox,
    'user-modal': UserModal,
    dropdown: Dropdown,
    'table-header-cell': TableHeaderCell,
  },
};
</script>

<style lang="scss" scoped>

.material-select {
  max-width: 240px;
  padding-top: 0;
  margin-left: 2px;
}

.flex-between {
  margin-top: 40px;
}
</style>
